import React, { useContext } from 'react'
import QuizContext from '../QuizContext'
import { useTouchQuestion, useSubmitQuestion } from '../store'
import { getNextItem, getPrevItem } from '@brainstud/react-helpers'

export default function (id) {
  const quiz = useContext(QuizContext)
  const question = quiz.state.questions.byId[id]
  const progress = quiz.state.progress[id]
  const quizProgress = quiz.state.progress.quiz
  const questionsById = quiz.state.questions.byId
  const questionsAllIds = quiz.state.questions.allIds

  const currentQIndex = questionsAllIds.indexOf(id) + 1 // Increment for UI, otherwise question 1 will be 0
  const progressbar = currentQIndex / quizProgress.totalQuestions * 100

  const isFirstQuestion = questionsAllIds.indexOf(id) === 0
  const isLastQuestion = questionsAllIds.indexOf(id) === questionsAllIds.length - 1

  const nextQuestion = getNextItem(questionsAllIds, questionsById, id) || {}
  const prevQuestion = getPrevItem(questionsAllIds, questionsById, id) || {}

  const prevQuestionProgress = quiz.state.progress[prevQuestion.id] || {}
  const prevQuestionStatus = prevQuestionProgress.submited && prevQuestionProgress.passed
    ? 'correct'
    : prevQuestionProgress.submited && !prevQuestionProgress.passed
      ? 'wrong'
      : ''

  const nextQuestionProgress = quiz.state.progress[nextQuestion.id] || {}
  const nextQuestionStatus = nextQuestionProgress.submited && nextQuestionProgress.passed
    ? 'correct'
    : nextQuestionProgress.submited && !nextQuestionProgress.passed
      ? 'wrong'
      : ''

  const onSubmitQuestion = () => {
    useSubmitQuestion(quiz.dispatch, id)
  }

  const onTouchQestion = data => {
    useTouchQuestion(quiz.dispatch, id, data, data => quiz.saveData(data))
  }

  return {
    onSubmitQuestion,
    onTouchQestion,
    quiz: quiz.state.quiz,
    quizProgress,
    question,
    progress,
    progressbar,
    currentQIndex,
    isFirstQuestion,
    isLastQuestion,
    prevQuestionStatus,
    nextQuestionStatus,
  }
}


// const quiz = useContext(QuizContext)


// console.log(state)
